<template>
    <div>
        <base-task-status
            :session_id="session.id"
            task_name="prudent_value"
            :finishedHook="handleTaskStatusFinished"
        />
    </div>
</template>


<script>
import ApiService from "@/components/utils/api.service.js"
import Utils from "@/components/utils/utils.js"
import BaseTaskStatus from "./BaseTaskStatus.vue"

export default {
    components: {
        BaseTaskStatus
    },
    props: {
        session: {
            type: Object,
            default: () => {}
        },
    },
    methods: {
        handleTaskStatusFinished: function(task_status) {
            this.$store.dispatch("retrieveSessionAppraisalValue", this.session.id);
            return ApiService
                .get(`/amas/analysis/api/prudent-value/${this.session.id}`)
                .then(response => {
                    let data = response.data;
                    let indication_value = data.indication_value;

                    let icon, tooltip, bg;
                    let url = `/amas/analysis/${this.session.id}/prudent-value/calculation`;
                    if (indication_value) {
                        icon = "fa fa-check";
                        bg = "success";
                        tooltip = Utils.formatCurrency(indication_value)
                    } else {
                        icon = "fa fa-close";
                        bg = "light";
                        tooltip = "Error"
                    }
                    return (`
                        <a href="${url}">
                            <span
                                class="circle circle-sm bg-${bg}"
                                data-toggle="tooltip" data-original-title="${tooltip}"
                            >
                                <i class="${icon}"></i>
                            </span>
                        </a>
                    `)
                })
        }
    },
}
</script>